import moment from 'moment';
import { ISelectedFilters } from 'src/app/models/filters/selectedFilters.interface';

export class FiltersQueryTransformer {
  private static readonly _paramsFiltersKeyValueSeparator = ':';
  private static readonly _paramsFiltersSeparator = ' ';
  private static readonly _paramsValueArraysSeparator = ',';
  private static readonly _searchParamKey = 'search';
  private static readonly _threadIdParamKey = 'threadid';
  private static readonly _searchValueEnclosingChar = '"';

  public static transformFromQuery(query: string): {
    [key: string]: string[];
  } {
    if (query === undefined || query == '') {
      return {};
    }

    const queryWithOnlyValidAsDictionary: { [key: string]: string[] } = {};

    // Handle query search param
    if (query.includes(`${this._searchParamKey}${this._paramsFiltersKeyValueSeparator}`)) {
      const searchTerm = query.substring(
        query.indexOf(this._searchValueEnclosingChar) + 1,
        query.lastIndexOf(this._searchValueEnclosingChar)
      );
      queryWithOnlyValidAsDictionary[this._searchParamKey] = [searchTerm];
      query = query.replace(
        `${this._searchParamKey}${this._paramsFiltersKeyValueSeparator}${this._searchValueEnclosingChar}${searchTerm}${this._searchValueEnclosingChar}`,
        ''
      );
    }

    // Handle rest of params
    const queryParamsArray = query.split(this._paramsFiltersSeparator);
    queryParamsArray.forEach((queryParam) => {
      const keyValueArray = queryParam.split(this._paramsFiltersKeyValueSeparator);
      let value: string | string[] = '';
      if (keyValueArray[0].toLowerCase() === this._threadIdParamKey) {
        value = keyValueArray.slice(1).join(this._paramsFiltersKeyValueSeparator);
      } else if (keyValueArray.length === 2) {
        value = keyValueArray[1];
      }
      if (value !== '') {
        const valueAfterSplit = value.split(this._paramsValueArraysSeparator);
        value = valueAfterSplit.filter((item) => item !== '');
        queryWithOnlyValidAsDictionary[keyValueArray[0]] = value;
      }
    });

    return queryWithOnlyValidAsDictionary;
  }

  public static transformToQuery<T = ISelectedFilters>(selectedFilters: T): string {
    let filtersQuery = '';
    const filtersAsDict = JSON.parse(JSON.stringify(selectedFilters));

    Object.keys(filtersAsDict).forEach((key) => {
      if (Array.isArray(filtersAsDict[key])) {
        if (filtersAsDict[key].length > 0) {
          filtersQuery = `${filtersQuery}${this._paramsFiltersSeparator}${key}${this._paramsFiltersKeyValueSeparator}${filtersAsDict[key].join(this._paramsValueArraysSeparator)}`;
        }
      } else {
        if (filtersAsDict[key] != undefined) {
          if (key === this._searchParamKey) {
            filtersQuery = `${filtersQuery}${this._paramsFiltersSeparator}${key}${this._paramsFiltersKeyValueSeparator}${this._searchValueEnclosingChar}${filtersAsDict[key].toString()}${this._searchValueEnclosingChar}`;
          } else if (!isNaN(Date.parse(filtersAsDict[key])) && moment(filtersAsDict[key]).isValid()) {
            filtersQuery = `${filtersQuery}${this._paramsFiltersSeparator}${key}${this._paramsFiltersKeyValueSeparator}${Date.parse(filtersAsDict[key])}`;
          } else {
            filtersQuery = `${filtersQuery}${this._paramsFiltersSeparator}${key}${this._paramsFiltersKeyValueSeparator}${filtersAsDict[key].toString()}`;
          }
        }
      }
    });
    filtersQuery = filtersQuery.trim();
    return filtersQuery;
  }
}
